module.exports = __webpack_public_path__ + "static/media/R&R_-set-5.c0a0642c.jpg";